import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setCurrentPage } from '@assetManagement/store/uploadVideo';
import Pagination from 'components/Pagination';
import styles from './UploadedVideosPagination.module.scss';

export default function UploadedVideosPagination({ currentPage, pageCount }) {
  const dispatch = useDispatch();

  const handlePageChange = useCallback(
    (event) => {
      dispatch(setCurrentPage(event.selected + 1));
    },
    [dispatch]
  );

  if (pageCount !== 0) {
    return (
      <Pagination
        onPageChange={handlePageChange}
        pageCount={pageCount}
        forcePage={currentPage - 1}
        className={styles.paginate}
      />
    );
  }
  return null;
}
